const state = {
  visible : false,
  player  : null
}
const getters = {
  visible : state => state.visible,
  player  : state => state.player
}
const mutations = {
  setPlayer  (state, player) { state.player = player },
  hidePlayer (state) { state.visible = false },
  showPlayer (state) { state.visible = true }
}
const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/video/store/youtube.js